import { Component } from '@angular/core';
import { ApplicationProxyService } from '../../../shared/services/applicationproxy.service';
import { FlowManagerService } from '../../../shared/services/flowmanager.service';

@Component({
  selector: 'success',
  template: require('./success.component.html')
})

export class SuccessComponent {
  constructor(appProxy: ApplicationProxyService, flowManager: FlowManagerService) {
    this.appProxy = appProxy;
    this.flowManager = flowManager;
  }

  continueBtnClicked(continueToSomewhere) {
    if (this.flowManager.isAuthed && this.flowManager.getAccountType() === 'select-custodial') {
      this.flowManager.ssoToAlly();
    } else {
      this.appProxy.getAccountsLink(res => {
        this.flowManager.canUnload = true;
        window.location.href = res.url;
      });
    }
  }
}
